import { useQuery } from "@tanstack/react-query";
import type { Property } from "@triple-h/shared";
import { publicApi } from "../api";
export type Discovery = {
  featured: Property[];
  latest: Property[];
  locations: { name: string; count: number }[];
  categories: Record<string, string>;
};
function initialDiscovery(): Discovery | undefined {
  try {
    const text = document.getElementById("tripleh-discovery")?.textContent;
    return text ? JSON.parse(text) : undefined;
  } catch {
    return undefined;
  }
}
export function useDiscovery() {
  return useQuery({
    initialData: initialDiscovery,
    queryKey: ["discovery"],
    queryFn: () => publicApi<Discovery>("/discovery"),
    staleTime: 60_000,
  });
}
